import { useEditDocumentContext } from 'shared/hooks/use-edit-document'
import { useFormik } from 'formik'
import { TDocFile } from 'shared/constants/docs'
import { FormTextField } from 'shared/_ui/form/form-text-field'
import { CardFieldsContainer } from 'shared/_ui/layout'

export default function FileNotes({ formik }: {
	// TODO: fix type. This brings an error on webapp build
	// formik: ReturnType<typeof useFormik<TDocFile>>;
	formik: ReturnType<typeof useFormik>;
}) {
	const { isEdit } = useEditDocumentContext();

	return (
		<CardFieldsContainer sx={{ minHeight: '15rem' }}>
			<FormTextField
				label="Notes:"
				name="notes"
				fullWidth
				formik={formik}
				labelProps={{ width: '4.75rem' }}
				multiline
				placeholder="Add notes about your file"
				spellCheck
				readOnly={!isEdit}
				// onReadOnlyClick={handleEnableEdit}
				// sx={fieldSx}
			/>
		</CardFieldsContainer>
	);
}
